// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.Collection = M.Collection || {};

/**
 * @class Collection.DatePickers
 *
 */
M.Collection.DatePickers = Backbone.Collection.extend({
  model: M.Model.DatePicker
});